// Library
import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";

const bem = new BemHelper("progress");

type Props = {
  activeStep: number;
};

export const Progress: React.FC<Props> = ({ activeStep }) => {
  const load = activeStep === 1 ? 0 : (100 / 3) * (activeStep - 1);

  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("title"))}>
        <div>Become a criyator</div>
        <div>{Math.floor(load)}/100</div>
      </div>
      <div className={classNames(bem.element("loader"))}>
        <div className={classNames(bem.element("status"))} style={{ width: load + "%" }} />
      </div>
    </div>
  );
};
